import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 匹配客户 获取用户信息或者非用户信息
 */
export const fetchServiceMemberInfo = async (params) => {
    const res = await GET(APIs.API_SERVICE_MEMBERINFO, { params });

    return res.data ?? {};
};

/**
 * 获取服务下拉框数据
 */
export const fetchServiceBasic = async () => {
    const res = await GET(APIs.API_BASIC_GETSERVICEBASIC);

    return res.data.data ?? {};
};

/**
 * 获取品牌数据
 */
export const fetchLeaseBrandList = async () => {
    const res = await GET(APIs.API_BASIC_GETLEASEBRANDLIST);

    return res.data.data ?? {};
};

/**
 * 获取租赁下拉框数据
 */
export const fetchLeaseBasic = async () => {
    const res = await GET(APIs.API_BASIC_GETLEASEBASIC);

    return res.data.data ?? {};
};

/**
 * 获取商品快递下拉框数据
 */
export const fetchExpressBasic = async () => {
    const res = await GET(APIs.API_BASIC_GETEXPRESSAGEBASIC);

    return res.data.data ?? {};
};

/**
 * 获取投诉下拉框数据
 */
export const fetchCasesBasic = async () => {
    const res = await GET(APIs.API_BASIC_GETCASESBASIC);

    return res.data.data ?? {};
};

/**
 * 获取失物招领下拉框数据
 */
export const fetchLoseBasic = async () => {
    const res = await GET(APIs.API_BASIC_LOSEBASIC);

    return res.data.data ?? {};
};

/**
 * 获取兑换平台数据
 */
export const fetchExchangePlatform = async () => {
    const res = await GET(APIs.API_BASIC_GETEXTERNALGIFTACTLIST);

    return res.data.data ?? {};
};